<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{ (participante && participante.id ? 'Editar Participante' : 'Adicionar Participante') | translate
      }}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-grid class="gradient-container"
    style="margin-top: -49px;"
  >
    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">
          {{pessoa.id ? pessoa.nome : ("Nenhuma Pessoa Selecionada" |
          translate)}}
        </p>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" *ngIf="!participante">
      <ion-col size="10" *ngIf="userProvider.hasConfig(123)">
        <div>
          <ion-button class="btn-default" expand="block" (click)="selecionarPessoa();">
            {{'Selecionar Pessoa' | translate}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" *ngIf="!participante">
      <ion-col size="auto">
        <div *ngIf="userProvider.hasConfig(122)">
          <p class="criar" (click)="criarParticipante();">
            {{'Criar Pessoa +' | translate}}
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card>
    <ion-card-content>
      <form class="sample-form validations-form" [formGroup]="validations_form"
        (ngSubmit)="onSubmit(validations_form.value)">
        <ion-row class="prover-datepicker">
          <ion-col size="12" class="remove-border">
            <ion-item>
              <ion-select labelPlacement="stacked" interface="action-sheet" label="{{'Função' | translate}}"
                placeholder="{{'Função' | translate}}" cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}" formControlName="idGrupoCargo">
                <ion-select-option [value]="0">{{'SELECIONE' | translate}}</ion-select-option>
                <ion-select-option *ngFor="let cargos of grupoCargos"
                  [value]="cargos.id">{{cargos.nome}}</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item *ngIf="userProvider.hasConfig(106)" class="premissao">
          <ion-label>{{'Permissão de Gerenciar' | translate}}?</ion-label>
          <ion-checkbox formControlName="permissaoPortal"></ion-checkbox>
        </ion-item>

        <ion-grid>
          <ion-row>
            <ion-col>
              <div class="down">
                <ion-button class="btn-success" expand="block" type="submit"
                  [disabled]="!validations_form.valid || !pessoa.id">
                  {{'Salvar' | translate}}
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </ion-card-content>
  </ion-card>
</ion-content>